var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "menu_cosmic_issue_tracker c-flex align-items-center",
    attrs: {
      "tooltip": "Get support"
    }
  }, [_c('c-menu', {
    staticClass: "menu_list",
    attrs: {
      "align-left": "",
      "border-color": "var(--cosmic-text)",
      "border-size": "1px",
      "nudge-top": "0px"
    }
  }, [_c('ButtonMiniActionNavbar', {
    attrs: {
      "slot": "activator",
      "icon": _vm.$icons.support_ticket,
      "disable-scale-on-hover": "",
      "icon-size": "18px"
    },
    slot: "activator"
  }), _c('c-menu-item', {
    attrs: {
      "icon": "fad fa-solid fa-question",
      "icon-color": "var(--cosmic-text)",
      "icon-size": "18px"
    },
    on: {
      "c-click": _vm.uiClickOfCreateQuestion
    }
  }, [_vm._v(" Ask a question ")]), _c('c-menu-item', {
    attrs: {
      "icon": "fad fa-solid fa-bugs",
      "icon-color": "var(--cosmic-text)",
      "icon-size": "18px"
    },
    on: {
      "c-click": _vm.uiClickOfCreateBug
    }
  }, [_vm._v(" Log a bug ")]), _c('c-menu-item', {
    attrs: {
      "icon": "fad fa-solid fa-lightbulb-on",
      "icon-color": "var(--cosmic-text)",
      "icon-size": "18px"
    },
    on: {
      "c-click": _vm.uiClickOfCreateFeature
    }
  }, [_vm._v(" Tell us about a feature ")]), _c('c-menu-item', {
    attrs: {
      "icon": _vm.$icons.application_reporting,
      "icon-color": "var(--cosmic-text)",
      "icon-size": "18px",
      "href": "/support_tickets/search"
    }
  }, [_c('div', {
    staticClass: "c-flex no-gap align-center",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', [_vm._v("View all issues")]), _c('div', {
    staticStyle: {
      "width": "20px",
      "text-align": "right"
    }
  })])])], 1), _vm.showModalCreateSupportTicket ? _c('AppModal', {
    attrs: {
      "color": "var(--cosmic-text)",
      "modal-width": "50vw"
    },
    on: {
      "modal-close": _vm.resetModals,
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.resetModals.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('div', {
          staticClass: "c-grid"
        }, [_c('AppMarkdown', {
          staticClass: "col-full mb-2",
          attrs: {
            "uploadingAttachments": true,
            "label": "Ticket description",
            "required": "",
            "placeholder": "Tell us what broke, when it happened, and how we can reproduce it"
          },
          model: {
            value: _vm.formData.description,
            callback: function ($$v) {
              _vm.$set(_vm.formData, "description", $$v);
            },
            expression: "formData.description"
          }
        })], 1), _c('AppFileUpload', {
          ref: "file_upload",
          staticClass: "mb-4",
          attrs: {
            "mb-max": 500,
            "multiple": ""
          },
          on: {
            "input": _vm.onFileSelected
          }
        }), _c('div', {
          staticClass: "c-flex flex-wrap",
          staticStyle: {
            "gap": "1rem"
          }
        }, [_vm._l(_vm.nonMicrosoftFiles, function (file, index) {
          return _c('div', {
            key: `non-ms-${index}`,
            staticClass: "preview_wrapper"
          }, [_c('AppFilePreview', {
            staticClass: "file_preview my-3 clickable_preview",
            attrs: {
              "file": file,
              "height": "200px",
              "pdf-width": "100%",
              "video-height": "100%",
              "video-width": "300px",
              "allow-clear": "",
              "show-download": ""
            },
            on: {
              "clear": function ($event) {
                _vm.removeFile(_vm.previewFiles.indexOf(file));
              }
            },
            nativeOn: {
              "click": function ($event) {
                return _vm.viewFile(file);
              }
            }
          })], 1);
        }), _vm._l(_vm.microsoftFiles, function (file, index) {
          return _c('div', {
            key: `ms-${index}`,
            staticClass: "preview_wrapper ms_file_card"
          }, [_c('div', {
            staticClass: "clear_selection_btn_wrapper"
          }, [_c('ButtonMiniAction', {
            staticClass: "clear_selection_btn",
            attrs: {
              "tooltip": "Clear file selection",
              "tooltip-position": "right"
            },
            on: {
              "click": function ($event) {
                _vm.removeFile(_vm.previewFiles.indexOf(file));
              }
            }
          }, [[_c('c-icon-fa', {
            attrs: {
              "icon": "fad fa-times-circle",
              "icon-color": "var(--v-secondary-base)"
            }
          })]], 2)], 1), _c('div', {
            staticClass: "c-flex",
            staticStyle: {
              "position": "absolute",
              "top": "8px",
              "right": "8px",
              "z-index": "7"
            }
          }, [_c('ButtonMiniAction', {
            staticClass: "gray_circle_btn",
            attrs: {
              "tooltip": "Download file",
              "tooltip-position": "bottom left"
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.triggerDownload(file);
              }
            }
          }, [[_c('c-icon-fa', {
            attrs: {
              "icon": "fad fa-download",
              "icon-color": "var(--cosmic-text)"
            }
          })]], 2)], 1), _c('div', {
            staticClass: "c-flex column align-center justify-center clickable_preview",
            staticStyle: {
              "height": "100%",
              "width": "100%",
              "background": "#f5f5f5",
              "border": "1px solid #e0e0e0",
              "border-radius": "4px"
            },
            on: {
              "click": function ($event) {
                return _vm.viewFile(file);
              }
            }
          }, [_c('div', {
            staticStyle: {
              "position": "relative"
            }
          }, [_c('c-icon-fa', {
            staticStyle: {
              "position": "absolute",
              "bottom": "-5px",
              "right": "-10px",
              "background": "white",
              "border-radius": "50%"
            },
            attrs: {
              "icon": "fas fa-question-circle",
              "icon-size": "28px",
              "icon-color": "var(--v-warning-base)"
            }
          })], 1), _c('div', {
            staticClass: "mt-3 text-center px-2 text-truncate",
            staticStyle: {
              "max-width": "100%",
              "font-size": "14px",
              "font-weight": "500"
            }
          }, [_vm._v(" " + _vm._s(file.name) + " ")])])]);
        })], 2), _vm.microsoftFiles.length > 0 ? _c('div', {
          staticClass: "col-full mt-3"
        }, [_c('AppPageDescription', {
          attrs: {
            "remove-margin-left": "",
            "color": "warning"
          }
        }, [_vm._v(" Microsoft Office files are currently unavailable for preview. Please download the file to view. ")])], 1) : _vm._e()];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function () {
        return [_vm.isUploading ? _c('div', {
          staticClass: "c-flex align-center"
        }, [_c('c-spinner', {
          staticClass: "mr-2",
          attrs: {
            "color": "var(--cosmic-text)"
          }
        }), _c('span', {
          staticClass: "mr-2"
        }, [_vm._v("Uploading attachment...")])], 1) : _vm._e(), !_vm.isUploading ? _c('ButtonCreate', {
          attrs: {
            "disabled": !_vm.formData.description || _vm.isUploading,
            "is-saving": _vm.isSaving
          },
          on: {
            "click": _vm.createSupportTicket
          }
        }) : _vm._e(), _c('ButtonCancel', {
          on: {
            "click": _vm.resetModals
          }
        }, [_vm._v("Cancel "), _c('small', {
          staticClass: "ml-2"
        }, [_vm._v("(esc)")])])];
      },
      proxy: true
    }], null, false, 3631833786)
  }) : _vm._e(), _vm.selectedFile ? _c('AppPanel', {
    attrs: {
      "max-width": "95vw"
    },
    on: {
      "panel-close": function ($event) {
        _vm.selectedFile = null;
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v(" Attachment Preview: " + _vm._s(_vm.selectedFile.name) + " ")];
      },
      proxy: true
    }, {
      key: "content",
      fn: function () {
        return [_c('AppFilePreview', {
          attrs: {
            "file": _vm.selectedFile,
            "height": "80vh",
            "pdf-width": "100%",
            "video-height": "100%",
            "video-width": "100%",
            "show-download": ""
          }
        })];
      },
      proxy: true
    }], null, false, 3655102382)
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };